import request from 'ynf-core-engine/request';
const MDF_PATH = '/mdf-node/qtmProxy'
const PRINT_BASE_PATH = '/ypd/print/'

// 打印
export const print = async function(params: any) {
  try {
    const res = await request({
      url: `${MDF_PATH}${PRINT_BASE_PATH}printPreview`,
      method: 'post',
      params: params.query,
      data: params.data
    });
    return res;
  } catch (err: any) {
    return Promise.reject(err)
  }
}

// 获取打印模板
export const getTemplateByBo = async function(params) {
  try {
    const res = await request({
      url: `${MDF_PATH}${PRINT_BASE_PATH}getTemplateByBo`,
      method: 'post',
      params: {
        ...params?.query,
        feV: 6
      },
      data: {
        ...params?.data
      }
    });
    return res;
  } catch (err: any) {
    return Promise.reject(err)
  }
}

// 直接打印/批量打印
export const tokenInfo = async function(params) {
  try {
    const res = await request({
      url: '/iuap-apcom-print/u8cprint/app/getTokenInfo',
      method: 'get',
      params: params.query,
      data: params.data
    });
    console.error(' 直接打印/批量打印', { res })
    return res;
  } catch (err: any) {
    return Promise.reject(err)
  }
}

// 直接打印/批量打印
export const directprint = async function(params) {
  try {
    const res = await request({
      url: 'http://127.0.0.1:9641/directprint',
      method: 'post',
      params: params.query,
      data: params.data
    });
    return res;
  } catch (err: any) {
    return Promise.reject(err)
  }
}
